module.exports = __webpack_public_path__ + "img/20190726161722QQ截图20190726022001.555dfe2e.png";